exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.introduction-trigger[data-v-d8cdf2f0] {\n  background-color: #f5e6fe;\n  padding: 80px 40px;\n}\n.introduction-trigger .trigger-card-wrapper[data-v-d8cdf2f0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    margin-left: 80px;\n}\n.introduction-trigger .trigger-card-wrapper[data-v-d8cdf2f0]:not(:first-child) {\n    margin-top: 40px;\n}\n@media screen and (max-width: 896px) {\n.introduction-trigger[data-v-d8cdf2f0] {\n    padding: 40px;\n}\n}\n@media screen and (max-width: 480px) {\n.introduction-trigger[data-v-d8cdf2f0] {\n    padding: 40px 16px;\n}\n.introduction-trigger .trigger-card-wrapper[data-v-d8cdf2f0] {\n    margin-left: 0;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d8cdf2f0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LP/organisms/IntroductionTrigger.vue
// module id = siKL
// module chunks = 3